import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAdminPartner, IAdminRecipient, IAdmins, IAdminsOBCheck } from 'store/admins/types';
import { initialState } from 'store/admins/initialState';

export const adminsSlice = createSlice({
  name: 'admins',
  initialState,
  reducers: {
    adminsStart: state => {
      state.isLoading = true;
      state.error = null;
    },

    adminsSuccess: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.isLoading = false;
    },

    adminCreatedSuccess: (state, action: PayloadAction<any>) => {
      if (state.data) {
        state.data.adminCreated = action.payload;
      }
      state.isLoading = false;
    },

    adminsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },

    adminsCleanUp: state => {
      if (state.data) {
        state.data.adminCreated = null;
      }
      state.error = null;
      state.OBCheck = null;
    },

    adminsOBCheckSuccess: (state, action: PayloadAction<IAdminsOBCheck>) => {
      state.OBCheck = action.payload;
      state.isLoading = false;
    },

    adminsRecipientsSuccess: (state, action: PayloadAction<IAdminRecipient[]>) => {
      state.recipients = action.payload;
      state.isLoading = false;
    },

    adminsPartnersSuccess: (state, action: PayloadAction<IAdminPartner[]>) => {
      state.partners = action.payload;
      state.isLoading = false;
    },

    adminsRecipientSelected: (state, action: PayloadAction<IAdminRecipient>) => {
      state.selectedRecipient = action.payload;
    },

    adminsActiveRole: (state, action: PayloadAction<string>) => {
      state.activeRole = action.payload;
    },

    adminsObStarted: state => {
      state.stripeOnboardingCalled = true;
      state.screenLoading = true;
    },

    adminsOBLinkSuccess: state => {
      state.isLoading = false;
      state.screenLoading = false;
      state.stripeOnboardingCalled = true;
    },

    adminDetailSuccess: (state, action: PayloadAction<IAdmins>) => {
      state.adminDetail = action.payload;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    // Handle legacy action types during migration from reduxsauce to createSlice
    // These allow old-style actions to still work while we gradually migrate
    builder
      .addCase('ADMINS_CLEAN_UP' as any, state => {
        if (state.data) {
          state.data.adminCreated = null;
        }
        state.error = null;
        state.OBCheck = null;
      })
      .addCase('ADMINS_PARTNERS_SUCCESS' as any, (state, action: any) => {
        state.partners = action.partners;
        state.isLoading = false;
      })
      .addCase('ADMIN_CREATED_SUCCESS' as any, (state, action: any) => {
        if (state.data) {
          state.data.adminCreated = action.data;
        }
        state.isLoading = false;
      })
      .addCase('ADMIN_DETAIL_SUCCESS' as any, (state, action: any) => {
        state.adminDetail = action.data;
        state.isLoading = false;
      })
      .addCase('ADMINS_ACTIVE_ROLE' as any, (state, action: any) => {
        state.activeRole = action.role;
      });
  },
});

export const {
  adminsStart,
  adminsSuccess,
  adminCreatedSuccess,
  adminsError,
  adminsCleanUp,
  adminsOBCheckSuccess,
  adminsRecipientsSuccess,
  adminsPartnersSuccess,
  adminsRecipientSelected,
  adminsActiveRole,
  adminsObStarted,
  adminsOBLinkSuccess,
  adminDetailSuccess,
} = adminsSlice.actions;

export default adminsSlice.reducer;
